import * as $$ from 'rxjs';

// tslint:disable: deprecation
import {
  buffer,
  bufferCount,
  catchError,
  concatMap,
  debounce,
  debounceTime,
  defaultIfEmpty,
  delay,
  distinctUntilChanged,
  filter,
  finalize,
  find,
  first,
  flatMap,
  last,
  map,
  mapTo,
  mergeAll,
  mergeMap,
  pairwise,
  pluck,
  reduce,
  scan,
  share,
  shareReplay,
  skip,
  skipUntil,
  startWith,
  switchAll,
  switchMap,
  switchMapTo,
  take,
  takeUntil,
  takeWhile,
  tap,
  throttle,
  throttleTime,
  toArray,
  withLatestFrom,
} from 'rxjs/operators';

export const rx = {
  buffer,
  bufferCount,
  catchError,
  concatMap,
  debounce,
  debounceTime,
  defaultIfEmpty,
  delay,
  distinctUntilChanged,
  filter,
  finalize,
  find,
  first,
  flatMap,
  last,
  map,
  mapTo,
  mergeAll,
  mergeMap,
  pairwise,
  pluck,
  reduce,
  scan,
  share,
  shareReplay,
  skip,
  skipUntil,
  startWith,
  switchAll,
  switchMap,
  switchMapTo,
  take,
  takeUntil,
  takeWhile,
  tap,
  throttle,
  throttleTime,
  toArray,
  withLatestFrom,
};

import { webSocket } from 'rxjs/webSocket';

export const rxWebSocket = {
  webSocket,
};


// tslint:disable-next-line: deprecation
export const observableEMPTY = $$.EMPTY;
export const observableForkJoin = $$.forkJoin;
export const observableOf = $$.of;
export const observableThrowError = $$.throwError;
export const observableIIF = $$.iif;
export const isObservable = $$.isObservable;

// ErrorObservable removed in rxjs 7, use throwError() instead
export {
  AsyncSubject,
  BehaviorSubject,
  Observable,
  ReplaySubject,
  Subject,
  Subscription,
} from 'rxjs';

